var Vue = require('vue');
var LoginCode = require('./Code/LoginCode').default;

module.exports = function() {
  const loginCodeEl = document.getElementById('login-code');

  if (loginCodeEl) {
    new Vue({
      el: loginCodeEl,
      components: {
        'login-code': LoginCode
      }
    });
  }
};
